import React from "react"
import { Switch as MUISwitch, SwitchProps } from "@mui/material"

import { useStyles } from "./styles"

const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  (props, ref) => {
    const { classes } = useStyles()
    const { onKeyDown, onChange, inputProps, ...otherProps } = props

    const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
      if (e.key === "Enter" && onChange) {
        e.preventDefault()
        const newChecked = !props.checked
        const syntheticEvent = {
          target: { checked: newChecked, value: String(newChecked) },
          currentTarget: { checked: newChecked, value: String(newChecked) }
        } as React.ChangeEvent<HTMLInputElement>
        onChange(syntheticEvent, newChecked)
      }
      onKeyDown?.(e)
    }

    // a11y: render the shared switch as role="switch" so AT announces it as a
    // switch (on/off state comes from `checked`); callers may override via inputProps
    return (
      <MUISwitch
        ref={ref}
        {...otherProps}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        className={classes.switch}
        inputProps={{
          role: "switch",
          ...inputProps
        }}
      />
    )
  }
)

export default Switch
